var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95302 3.12597C5.87765 3.04799 5.77908 3 5.66893 3C5.44281 3 5.26888 3.17996 5.26888 3.41392C5.26888 3.52789 5.30947 3.63587 5.37904 3.70786L9.73898 8.00299L5.37904 12.2861C5.30947 12.3641 5.26888 12.4781 5.26888 12.5861C5.26888 12.82 5.44281 13 5.66892 13C5.77908 13 5.87185 12.952 5.95302 12.874L10.5797 8.32694C10.6666 8.23695 10.7246 8.12297 10.7246 7.997C10.7246 7.87102 10.6724 7.76904 10.5797 7.67306L5.95302 3.12597Z",
    fill: "white",
    stroke: "#1080FF",
    strokeWidth: 0.96639
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/link2.d531f3e7.svg";
export { ForwardRef as ReactComponent };